/** Base64 (standard alphabet, with padding) as the server sends and expects it. */
export function fromBase64(text: string): Uint8Array<ArrayBuffer> {
  const binary = atob(text);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return bytes;
}

export function toBase64(bytes: Uint8Array): string {
  let binary = "";
  for (let i = 0; i < bytes.length; i += 0x8000) binary += String.fromCharCode(...bytes.subarray(i, i + 0x8000));
  return btoa(binary);
}

const utf8 = new TextDecoder();
export const decodeUtf8 = (bytes: Uint8Array) => utf8.decode(bytes);
export const encodeUtf8 = (text: string) => new TextEncoder().encode(text);
